import type { VisionRow } from '../../productgovernance/framework';

type Props = { items?: VisionRow[] };

export function ProductVisionPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.area} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm font-medium">{item.area}</p>
            <span className="shrink-0 rounded-full bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300">
              {item.status}
            </span>
          </div>
          <p className="mt-1 text-xs text-slate-500">{item.value}</p>
        </div>
      ))}
    </div>
  );
}
